import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import { Typo, TypoVariant } from '@travelata-libs/ui-kit';

    interface EmiratesFilterButtonProps {
        modelValue: boolean;
    }

    interface EmiratesFilterButtonEmits {
        (event: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EmiratesFilterButton',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (event: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

    
    

return { __sfc: true,emit, Typo, TypoVariant }
}

})